import common from 'store/modules/common/api'

export const api = {
  ...common.apiMethods('Producers'),
  saveAsSupplier: (entity) => common.httpClient.put(`/api/services/app/Producers/SaveAsSupplier`, entity, common.options()).then(r => common.processResponse(r))
}
